import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import RoutesConfig from './routes';
import AuthPage from './pages/auth';
import useAuthState from './hooks/useAuthState';
import SidebarLayout from './components/layouts/sidebars';
import useGeneralStore from './store/useGeneralStore';
import { useEffect } from 'react';
import { fetchUsers } from 'common/src/api/users';
import { CategoriesProvider } from './contexts/CategoriesContext';
import * as Sentry from "@sentry/react";
import { POSTHOG_URL } from './types/api';

if (typeof window !== 'undefined') {
  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: POSTHOG_URL,
    loaded: (posthog) => {
      posthog.debug(import.meta.env.PROD);
    },
  });
}


Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_KEY,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // TODO cambiar para que dejemos un proyecto de admin, asker, edge-functions y common. Hay que entender la logica de operacion con un monorepo
  tracePropagationTargets: ["https://admin.taskyapp.cl/"],
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const App = () => {
  const { session, loading } = useAuthState();
  const { setUsers } = useGeneralStore();

  useEffect(() => {
    const loadUsers = async () => {
      try {
        const userData = await fetchUsers();
        setUsers(userData);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    loadUsers();
  }, [setUsers]);

  useEffect(() => {
    if (session && session.user && session.user.email) {
      posthog.identify(session.user.email, {
        email: session.user.email,
        // You can add more user properties here if needed
      });
    }
  }, [session]);

  if (loading) {
    return null;
  }

  return (
    <PostHogProvider client={posthog}>
      <CategoriesProvider>
        {!session ? (
          <AuthPage />
        ) : (
          <>
            <ToastContainer />
            <SidebarLayout>
              <RoutesConfig />
            </SidebarLayout>
          </>
        )}
      </CategoriesProvider>
    </PostHogProvider>
  );
};

export default App;
